<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <KTCodePreview v-bind:title="'Chương trình thưởng AdHoc V2'">
          <template v-slot:toolbar>
            <div class="row">
              <div class="ml-3">
                <button
                  type="button"
                  class="btn btn-primary font-weight-bolder btn-sm"
                  @click="addNew"
                >
                  <i style="font-size: 1rem" class="flaticon2-add-1"></i>Tạo mới
                </button>
              </div>
            </div>
          </template>
          <template v-slot:preview>
            <!-- Bộ lọc -->
            <div class="col-md-12 mb-5 pl-0">
              <b-row>
                <b-col md="2" class="pl-0">
                  <b-input
                    size="sm"
                    placeholder="Tìm theo tên chương trình"
                    v-model="filter.keyword"
                    autocomplete="off"
                    v-on:input="debounceSearch"
                  ></b-input>
                </b-col>
                <b-col md="3">
                  <Autosuggest
                    :model.sync="filter.itemText"
                    :suggestions="itemSuggestions"
                    placeholder="sản phẩm được thưởng"
                    :limit="10"
                    @select="onSelectItem"
                    @change="onSearchItem"
                    suggestionName="suggestionName"
                  />
                </b-col>
                <b-col md="2">
                  <b-form-select
                    size="sm"
                    v-model="filter.status"
                    :options="statusOptions"
                    value-field="id"
                    text-field="name"
                    @change="onFilter"
                  >
                    <template v-slot:first>
                      <b-form-select-option :value="null"
                        >-- Tất cả trạng thái --</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-col>
                <b-col md="2">
                  <date-picker
                    placeholder="Từ ngày"
                    class="form-control form-control-sm"
                    :config="dpConfigs.date"
                    v-model="filter.fromDate"
                  ></date-picker>
                </b-col>
                <b-col md="2">
                  <date-picker
                    placeholder="Đến ngày"
                    class="form-control form-control-sm"
                    :config="dpConfigs.date"
                    v-model="filter.toDate"
                  ></date-picker>
                </b-col>
                <b-col md="1">
                  <b-button
                    style="width: 70px"
                    variant="primary"
                    size="sm"
                    @click="onFilter"
                    >Lọc</b-button
                  >
                </b-col>
              </b-row>
            </div>

            <b-table
              :items="items"
              :fields="fields"
              bordered
              hover
              :busy="onLoading"
              show-empty
              empty-text="Không có chương trình AdHoc nào"
            >
              <template v-slot:table-busy>
                <vcl-table :speed="5" :animate="true" :columns="7"></vcl-table>
              </template>
              <template v-slot:cell(count)="row">
                {{ (page - 1) * PAGE_LIMIT + row.index + 1 }}
              </template>
              <template v-slot:cell(period)="row">
                <span>{{ formatShortDate(row.item.startDate) }}</span>
                <span> — </span>
                <span v-if="row.item.endDate">{{
                  formatShortDate(row.item.endDate)
                }}</span>
                <span v-else class="text-muted">không giới hạn</span>
              </template>
              <!-- Phạm vi áp dụng: bán lẻ + bán buôn tách riêng cho dễ soát -->
              <template v-slot:cell(scope)="row">
                <div>
                  <b-badge
                    v-if="row.item.applyAllRetailStores"
                    variant="success"
                    class="mr-1"
                    >Toàn bộ bán lẻ</b-badge
                  >
                  <b-badge
                    v-else-if="row.item.retailStoreCount"
                    variant="light"
                    class="mr-1"
                    >{{ row.item.retailStoreCount }} CH bán lẻ</b-badge
                  >
                </div>
                <div class="mt-1">
                  <b-badge
                    v-if="row.item.applyAllWholesaleStores"
                    variant="info"
                    class="mr-1"
                    >Toàn bộ bán buôn</b-badge
                  >
                  <b-badge
                    v-else-if="row.item.wholesaleStoreCount"
                    variant="light"
                    class="mr-1"
                    >{{ row.item.wholesaleStoreCount }} CH bán buôn</b-badge
                  >
                </div>
              </template>
              <template v-slot:cell(status)="row">
                <span
                  class="label font-weight-bold label-lg label-inline"
                  :class="statusVariant(row.item.status)"
                  >{{ statusName(row.item.status) }}</span
                >
              </template>
              <template v-slot:cell(actions)="row">
                <div class="d-flex justify-content-center">
                  <b-dropdown size="sm" no-caret right>
                    <template slot="button-content">
                      <i
                        style="font-size: 1rem; padding-right: 0px"
                        class="flaticon2-settings"
                      ></i>
                    </template>
                    <b-dropdown-item @click="editItem(row.item)">
                      <span style="color: #3f4254; font-size: 12px">
                        <i style="font-size: 1rem" class="flaticon2-pen"></i>
                        &nbsp; Chỉnh sửa
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="showCopyModal(row.item)">
                      <span style="color: #3f4254; font-size: 12px">
                        <i style="font-size: 1rem" class="far fa-copy"></i>
                        &nbsp; Sao chép
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="showStatusModal(row.item)">
                      <span style="color: #3f4254; font-size: 12px">
                        <i
                          style="font-size: 1rem"
                          class="fas fa-exchange-alt"
                        ></i>
                        &nbsp; Đổi trạng thái
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="showHistory(row.item)">
                      <span style="color: #3f4254; font-size: 12px">
                        <i style="font-size: 1rem" class="fas fa-history"></i>
                        &nbsp; Lịch sử
                      </span>
                    </b-dropdown-item>
                    <b-dropdown-item @click="showDeleteAlert(row.item)">
                      <span style="color: #3f4254; font-size: 12px">
                        <i
                          style="font-size: 1rem; color: #d33"
                          class="flaticon2-rubbish-bin-delete-button"
                        ></i>
                        &nbsp; Xóa
                      </span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
            </b-table>

            <b-row>
              <b-col>
                <p class="mt-3 text-dark" style="font-weight: 500">
                  Tổng số chương trình: {{ totalItems }}
                </p>
              </b-col>
              <b-col>
                <b-pagination-nav
                  class="custom-pagination"
                  v-show="totalPages >= 2"
                  :link-gen="linkGen"
                  :number-of-pages="totalPages"
                  use-router
                  @change="fetchData"
                  align="right"
                  first-class="page-item-first btn btn-icon btn-sm mr-1 my-1"
                  prev-class="page-item-prev btn btn-icon btn-sm mr-.5 my-1"
                  next-class="page-item-next btn btn-icon btn-sm mr-1 my-1 ml-.5"
                  last-class="page-item-last btn btn-icon btn-sm my-1"
                  page-class="btn btn-icon btn-sm border-0 mr-.5 my-1"
                >
                  <template v-slot:first-text>
                    <span>
                      <i class="ki ki-bold-double-arrow-back icon-xs"></i>
                    </span>
                  </template>
                  <template v-slot:prev-text>
                    <i class="ki ki-bold-arrow-back icon-xs"></i>
                  </template>
                  <template v-slot:next-text>
                    <i class="ki ki-bold-arrow-next icon-xs"></i>
                  </template>
                  <template v-slot:last-text>
                    <span class="text-info">
                      <i class="ki ki-bold-double-arrow-next icon-xs"></i>
                    </span>
                  </template>
                </b-pagination-nav>
              </b-col>
            </b-row>
          </template>
        </KTCodePreview>
      </div>
    </div>

    <!-- Đổi trạng thái -->
    <b-modal
      v-model="statusModalVisible"
      title="Đổi trạng thái chương trình"
      @ok="confirmChangeStatus"
      ok-title="Cập nhật"
      cancel-title="Huỷ"
      :ok-disabled="isUpdatingStatus"
    >
      <p class="mb-3">
        Chương trình: <strong>{{ statusModel.name }}</strong>
      </p>
      <b-form-select
        size="sm"
        v-model="statusModel.status"
        :options="statusOptions"
        value-field="id"
        text-field="name"
      ></b-form-select>
    </b-modal>

    <!-- Sao chép: sửa nhanh tên / kỳ / trạng thái rồi tạo bản mới,
         phạm vi cửa hàng và các dòng chi tiết giữ nguyên như chương trình nguồn -->
    <b-modal
      v-model="copyModalVisible"
      title="Sao chép chương trình thưởng AdHoc"
      size="lg"
      no-close-on-backdrop
      @hidden="resetCopyModel"
    >
      <div v-if="isLoadingCopySource" class="text-center text-muted py-5">
        <b-spinner small class="mr-2"></b-spinner>Đang tải chương trình nguồn...
      </div>
      <template v-else-if="copySource">
        <b-row>
          <b-col md="12">
            <b-form-group>
              <label
                >Tên chương trình <span class="text-danger">*</span></label
              >
              <b-form-input
                size="sm"
                v-model="copyModel.name"
                placeholder="Nhập tên chương trình AdHoc"
                autocomplete="off"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <b-form-group>
              <label>Từ ngày <span class="text-danger">*</span></label>
              <date-picker
                placeholder="Từ ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="copyModel.startDate"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Đến ngày <span class="text-danger">*</span></label>
              <date-picker
                placeholder="Đến ngày"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                v-model="copyModel.endDate"
              ></date-picker>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label>Trạng thái</label>
              <b-form-select
                size="sm"
                v-model="copyModel.status"
                :options="statusOptions"
                value-field="id"
                text-field="name"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group>
          <label>Mô tả</label>
          <b-form-textarea
            size="sm"
            rows="2"
            v-model="copyModel.description"
            placeholder="Mô tả chương trình"
          ></b-form-textarea>
        </b-form-group>

        <!-- Tóm tắt phần được sao chép nguyên trạng (chỉ đọc) -->
        <b-alert show variant="light" class="mb-0 copy-summary">
          <div class="font-weight-bold mb-1">Sao chép từ chương trình nguồn:</div>
          <ul class="mb-0 pl-4">
            <li>Bán lẻ: {{ copySummary.retail }}</li>
            <li>Bán buôn: {{ copySummary.wholesale }}</li>
            <li>Chi tiết thưởng: {{ copySummary.detailCount }} dòng</li>
          </ul>
        </b-alert>
      </template>

      <template v-slot:modal-footer>
        <b-button
          variant="primary"
          size="sm"
          style="width: 70px"
          :disabled="isCopying || isLoadingCopySource || !copySource"
          @click="saveCopy"
          >{{ isCopying ? 'Đang lưu...' : 'Lưu' }}</b-button
        >
        <b-button
          variant="secondary"
          size="sm"
          style="width: 70px"
          @click="copyModalVisible = false"
          >Hủy</b-button
        >
      </template>
    </b-modal>

    <HistoryModal
      ref="history-modal"
      modal-id="commission-adhoc-history-modal"
      title="Lịch sử thay đổi chương trình thưởng AdHoc"
    />
  </div>
</template>

<script>
/**
 * Danh sách chương trình thưởng AdHoc V2 — SRS F-06.
 *
 * Xoá: BẮT BUỘC xác nhận vì xoá chương trình làm thay đổi hoa hồng AdHoc đã tính
 * cho nhân viên; API trả thêm `warning` khi chương trình đã phát sinh hoa hồng.
 * Chỉ muốn dừng thì nên đổi trạng thái sang "Ngưng áp dụng".
 * Sao chép: mở modal sửa tên / kỳ / trạng thái / mô tả rồi tạo mới ngay,
 * phạm vi cửa hàng và các dòng chi tiết lấy nguyên từ chương trình nguồn.
 * Màn MỚI, không dùng lại /reward/reward-adhoc cũ.
 *
 * Điểm khác bản cũ: cột "Phạm vi" hiện rõ áp dụng cho bao nhiêu cửa hàng
 * BÁN LẺ và bao nhiêu cửa hàng BÁN BUÔN (hoặc cờ áp dụng toàn bộ kênh).
 */
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import Swal from 'sweetalert2';
import debounce from 'debounce';
import moment from 'moment';
import datePicker from 'vue-bootstrap-datetimepicker';
import { VclTable } from 'vue-content-loading';
import { TIME_TRIGGER } from '@/utils/constants';
import { formatDate, makeToastSuccess, makeToastFaile } from '@/utils/common';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import HistoryModal from './HistoryModal.vue';
import {
  COMMISSION_ADHOC_STATUS,
  COMMISSION_ADHOC_STATUS_NAME,
  COMMISSION_ADHOC_STATUS_VARIANT,
  COMMISSION_ADHOC_CONDITION_LOGIC,
  COMMISSION_ADHOC_REWARD_MODE,
  COMMISSION_ADHOC_ITEM_TYPE,
  COMMISSION_SEARCH_TYPE,
  COMMISSION_STORE_SCOPE,
  toOptionList,
} from './commission.constants';

const PAGE_LIMIT = 10;
const DATE_INPUT_FORMAT = 'DD/MM/YYYY';
const DATE_API_FORMAT = 'YYYY-MM-DD';

export default {
  components: { KTCodePreview, VclTable, datePicker, HistoryModal, Autosuggest },
  data() {
    return {
      PAGE_LIMIT,
      onLoading: false,
      isUpdatingStatus: false,
      items: [],
      totalPages: 0,
      totalItems: 0,
      page: 1,
      filter: {
        keyword: '',
        status: null,
        fromDate: '',
        toDate: '',
        itemType: COMMISSION_ADHOC_ITEM_TYPE.PRODUCT,
        itemId: null,
        itemText: '',
      },
      itemSuggestions: [],
      selectedItemText: '',
      statusModalVisible: false,
      statusModel: { id: null, name: '', status: COMMISSION_ADHOC_STATUS.ACTIVE },
      statusOptions: toOptionList(COMMISSION_ADHOC_STATUS_NAME),
      copyModalVisible: false,
      isLoadingCopySource: false,
      isCopying: false,
      copySource: null,
      copyModel: this.emptyCopyModel(),
      dpConfigs: {
        date: {
          format: DATE_INPUT_FORMAT,
          useCurrent: false,
          showClear: true,
          showClose: true,
          locale: 'vi',
        },
      },
      linkGen: (pageNum) => (pageNum === 1 ? '?' : `?page=${pageNum}`),
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-center',
        },
        {
          key: 'name',
          label: 'Tên chương trình',
          thStyle: { fontWeight: 600, color: '#181c32', width: '28%' },
        },
        {
          key: 'period',
          label: 'Thời gian áp dụng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
        },
        {
          key: 'scope',
          label: 'Phạm vi áp dụng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '18%' },
        },
        {
          key: 'detailCount',
          label: 'Số dòng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '9%' },
          tdClass: 'text-center',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          thStyle: { fontWeight: 600, color: '#181c32', width: '13%' },
          tdClass: 'text-center',
        },
        {
          key: 'actions',
          label: '',
          thStyle: { fontWeight: 600, color: '#181c32', width: '7%' },
        },
      ],
    };
  },
  computed: {
    /** Tóm tắt phạm vi + số dòng sẽ được sao chép từ chương trình nguồn */
    copySummary() {
      const source = this.copySource || {};
      const stores = source.stores || [];
      const retailCount = stores.filter(
        (row) => Number(row.scope) === COMMISSION_STORE_SCOPE.RETAIL,
      ).length;
      const wholesaleCount = stores.filter(
        (row) => Number(row.scope) === COMMISSION_STORE_SCOPE.WHOLESALE,
      ).length;
      return {
        retail:
          Number(source.applyAllRetailStores) === 1
            ? 'Toàn bộ cửa hàng bán lẻ'
            : `${retailCount} cửa hàng`,
        wholesale:
          Number(source.applyAllWholesaleStores) === 1
            ? 'Toàn bộ cửa hàng bán buôn'
            : `${wholesaleCount} cửa hàng`,
        detailCount: (source.details || []).length,
      };
    },
  },
  created() {
    this.page = Number(this.$route.query.page) || 1;
    this.fetchData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Hoa hồng', route: '/commission/categories' },
      { title: 'Chương trình thưởng AdHoc' },
    ]);
  },
  methods: {
    statusName(status) {
      return COMMISSION_ADHOC_STATUS_NAME[Number(status)] || '';
    },
    statusVariant(status) {
      return COMMISSION_ADHOC_STATUS_VARIANT[Number(status)] || 'label-light';
    },
    formatShortDate(value) {
      return value ? formatDate(value, DATE_INPUT_FORMAT) : '';
    },
    /** 'DD/MM/YYYY' -> 'YYYY-MM-DD'; bỏ qua nếu người dùng gõ dở */
    toApiDate(value) {
      if (!value) {
        return undefined;
      }
      const parsed = moment(value, DATE_INPUT_FORMAT, true);
      return parsed.isValid() ? parsed.format(DATE_API_FORMAT) : undefined;
    },
    debounceSearch: debounce(function () {
      this.onFilter();
    }, TIME_TRIGGER),
    onFilter() {
      this.page = 1;
      this.fetchData();
    },
    /* ---------------- Lọc theo sản phẩm được thưởng ---------------- */
    onSearchItem(text) {
      this.filter.itemText = text;
      // Chọn xong thư viện bắn lại sự kiện gõ với đúng tên vừa chọn — bỏ qua
      if (this.filter.itemId && text === this.selectedItemText) {
        return;
      }
      // Gõ khác đi là bỏ lựa chọn cũ và tải lại danh sách không lọc
      if (this.filter.itemId) {
        this.filter.itemId = null;
        this.onFilter();
      }
      this.debounceSearchItem(text, this.filter.itemType);
    },
    debounceSearchItem: debounce(function (text, type) {
      if (!text) {
        this.itemSuggestions = [];
        return;
      }
      const typeSearch =
        Number(type) === COMMISSION_ADHOC_ITEM_TYPE.CATEGORY
          ? COMMISSION_SEARCH_TYPE.CATEGORY
          : COMMISSION_SEARCH_TYPE.PRODUCT;
      ApiService.setHeader();
      ApiService.get(
        `productSearch/search-by-product-category?searchProduct=${encodeURIComponent(
          text,
        )}&typeSearch=${typeSearch}&typeOfProduct=0`,
      )
        .then(({ data }) => {
          this.itemSuggestions = (data.data || []).map((item) => ({
            id: item.id,
            suggestionName: item.code
              ? `${item.code} - ${item.name || item.productName}`
              : item.name || item.productName,
          }));
        })
        .catch(() => {
          this.itemSuggestions = [];
        });
    }, TIME_TRIGGER),
    onSelectItem(option) {
      this.selectedItemText = option.item.suggestionName;
      this.filter.itemId = option.item.id;
      this.filter.itemText = option.item.suggestionName;
      this.itemSuggestions = [];
      this.onFilter();
    },
    fetchData(pageNum) {
      if (pageNum) {
        this.page = pageNum;
      }
      this.onLoading = true;
      const params = {
        page: this.page,
        limit: PAGE_LIMIT,
        keyword: this.filter.keyword || undefined,
        status: this.filter.status || undefined,
        fromDate: this.toApiDate(this.filter.fromDate),
        toDate: this.toApiDate(this.filter.toDate),
        productId: this.filter.itemId || undefined,
      };
      ApiService.query('commission-adhocs', { params })
        .then(({ data }) => {
          this.items = data.data.items || [];
          this.totalItems = data.data.pagination.totalItems || 0;
          this.totalPages = data.data.pagination.totalPages || 0;
        })
        .catch((error) => {
          makeToastFaile(
            this.getErrorMessage(error, 'Không tải được danh sách'),
          );
        })
        .finally(() => {
          this.onLoading = false;
        });
    },
    addNew() {
      this.$router.push({ name: 'commission-upsert-adhoc' });
    },
    editItem(item) {
      this.$router.push({
        name: 'commission-upsert-adhoc',
        query: { id: item.id },
      });
    },
    showStatusModal(item) {
      this.statusModel = {
        id: item.id,
        name: item.name,
        status: Number(item.status),
      };
      this.statusModalVisible = true;
    },
    confirmChangeStatus() {
      this.isUpdatingStatus = true;
      ApiService.patch(`commission-adhocs/${this.statusModel.id}/status`, {
        status: this.statusModel.status,
      })
        .then(({ data }) => {
          makeToastSuccess(data.message);
          this.fetchData();
        })
        .catch((error) => {
          makeToastFaile(
            this.getErrorMessage(error, 'Không cập nhật được trạng thái'),
          );
        })
        .finally(() => {
          this.isUpdatingStatus = false;
        });
    },
    showHistory(item) {
      this.$refs['history-modal'].show(`commission-adhocs/${item.id}/histories`);
    },

    /* --------------------------------- Xoá --------------------------------- */
    showDeleteAlert(item) {
      Swal.fire({
        title: 'Xóa chương trình thưởng AdHoc',
        html:
          `Bạn có chắc muốn xóa chương trình "<b>${this.escapeHtml(item.name)}</b>" không?<br/>` +
          'Xóa chương trình sẽ ảnh hưởng đến hoa hồng AdHoc đã tính cho nhân viên ' +
          'trong thời gian áp dụng. Thao tác này không thể hoàn tác.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(221, 51, 51)',
        cancelButtonColor: '#E5EAEE',
        confirmButtonText: 'Xóa',
        cancelButtonText: '<span style="color:#464E5F">Hủy</span>',
        reverseButtons: true,
        position: 'top',
      }).then((result) => {
        if (result.value) {
          this.deleteItem(item);
        }
      });
    },
    deleteItem(item) {
      ApiService.setHeader();
      ApiService.delete(`commission-adhocs/${item.id}`).then((response) => {
        // ApiService.delete đã tự toast lỗi và trả về đối tượng error khi thất bại
        if (!response || !response.data) {
          return;
        }
        const result = response.data.data || {};
        makeToastSuccess(
          response.data.message || 'Xóa chương trình thưởng AdHoc thành công!',
        );
        // Chương trình đã phát sinh hoa hồng -> nhắc lại để người dùng biết cần soát lại
        if (result.warning) {
          Swal.fire({
            title: 'Lưu ý',
            text: result.warning,
            icon: 'info',
            confirmButtonText: 'Đã hiểu',
            position: 'top',
          });
        }
        this.fetchData();
      });
    },
    /** Tên chương trình do người dùng nhập — escape trước khi đưa vào html của Swal */
    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },

    /* ------------------------------- Sao chép ------------------------------- */
    emptyCopyModel() {
      return {
        name: '',
        startDate: '',
        endDate: '',
        status: COMMISSION_ADHOC_STATUS.ACTIVE,
        description: '',
      };
    },
    resetCopyModel() {
      this.copySource = null;
      this.copyModel = this.emptyCopyModel();
    },
    showCopyModal(item) {
      this.resetCopyModel();
      this.copyModalVisible = true;
      this.isLoadingCopySource = true;
      ApiService.setHeader();
      ApiService.query(`commission-adhocs/${item.id}`)
        .then(({ data }) => {
          const source = data.data || {};
          this.copySource = source;
          this.copyModel = {
            name: `${source.name || item.name} - Copy`,
            startDate: this.toInputDate(source.startDate),
            endDate: this.toInputDate(source.endDate),
            status: Number(source.status) || COMMISSION_ADHOC_STATUS.ACTIVE,
            description: source.description || '',
          };
        })
        .catch((error) => {
          makeToastFaile(
            this.getErrorMessage(error, 'Không tải được chương trình nguồn'),
          );
          this.copyModalVisible = false;
        })
        .finally(() => {
          this.isLoadingCopySource = false;
        });
    },
    toInputDate(value) {
      return value ? moment(value).format(DATE_INPUT_FORMAT) : '';
    },
    /** Payload tạo mới = chương trình nguồn (giống UpsertAdhoc.buildPayload) + phần sửa trong modal */
    buildCopyPayload() {
      const source = this.copySource;
      const applyAllRetail = Number(source.applyAllRetailStores) === 1;
      const applyAllWholesale = Number(source.applyAllWholesaleStores) === 1;
      const stores = (source.stores || [])
        .filter((row) =>
          Number(row.scope) === COMMISSION_STORE_SCOPE.RETAIL
            ? !applyAllRetail
            : !applyAllWholesale,
        )
        .map((row) => ({ storeId: row.storeId, scope: Number(row.scope) }));

      return {
        name: (this.copyModel.name || '').trim(),
        description: this.copyModel.description,
        startDate: this.toApiDate(this.copyModel.startDate) || null,
        endDate: this.toApiDate(this.copyModel.endDate) || null,
        status: this.copyModel.status,
        applyAllRetailStores: applyAllRetail ? 1 : 0,
        applyAllWholesaleStores: applyAllWholesale ? 1 : 0,
        stores,
        details: (source.details || []).map((detail, index) => ({
          type: Number(detail.type),
          referenceId: detail.referenceId,
          amount1: this.toAmount(detail.amount1),
          amount1Operator: Number(detail.amount1Operator) || 1,
          amount2: this.toAmount(detail.amount2),
          amount2Operator: Number(detail.amount2Operator) || 1,
          conditionLogic:
            Number(detail.conditionLogic) || COMMISSION_ADHOC_CONDITION_LOGIC.OR,
          rewardMode:
            Number(detail.rewardMode) || COMMISSION_ADHOC_REWARD_MODE.MAX,
          conditionCategoryIds: (detail.conditions || []).map(
            (c) => c.commissionAdhocCategoryId,
          ),
          sortOrder: index,
          employeeRates: (detail.employeeRates || [])
            .map((rate) => ({
              jobTitleId: Number(rate.jobTitleId),
              amount: Number(rate.amount) || 0,
            }))
            .filter((rate) => rate.amount > 0),
        })),
      };
    },
    /** API trả số tiền dạng chuỗi thập phân — rỗng thì coi như không giới hạn */
    toAmount(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }
      const numeric = Number(value);
      return Number.isNaN(numeric) ? null : numeric;
    },
    saveCopy() {
      if (!this.copySource) {
        return;
      }
      const payload = this.buildCopyPayload();
      if (!payload.name) {
        return makeToastFaile('Vui lòng nhập tên chương trình');
      }
      if (!payload.startDate) {
        return makeToastFaile('Vui lòng chọn ngày bắt đầu');
      }
      if (!payload.endDate) {
        return makeToastFaile('Vui lòng chọn ngày kết thúc');
      }

      this.isCopying = true;
      ApiService.setHeader();
      ApiService.post('commission-adhocs', payload)
        .then(({ data }) => {
          makeToastSuccess(data.message || 'Sao chép chương trình thành công!');
          this.copyModalVisible = false;
          this.fetchData();
        })
        .catch((error) => {
          makeToastFaile(
            this.getErrorMessage(error, 'Không sao chép được chương trình'),
          );
        })
        .finally(() => {
          this.isCopying = false;
        });
    },
  },
};
</script>

<style scoped>
.copy-summary {
  font-size: 13px;
  border: 1px dashed #d6d9e0;
}
</style>
